import { Alerta, Adjuntos, Button, DataList, Desplegable, MetricCard, Spinner, Stack } from "@/components";
import { MENSAJE_SIN_FICHA } from "@/lib/aportes";
import { useMiCuentaTab } from "./useMiCuentaTab";

type FilaAporte = ReturnType<typeof useMiCuentaTab>["aportes"][number];

const columnas = [
  { clave: "fecha", titulo: "Fecha", render: (a: FilaAporte) => a.fecha },
  { clave: "monto", titulo: "Monto", render: (a: FilaAporte) => a.monto },
  { clave: "nota", titulo: "Nota", render: (a: FilaAporte) => a.nota ?? "—" },
];

export function MiCuentaTab() {
  const t = useMiCuentaTab();
  return (
    <Stack espacio={6}>
      <h1 className="text-pantalla font-light tracking-[-0.03em]">Mi cuenta</h1>
      {t.cargando && (
        <div className="grid place-items-center py-10 text-primario">
          <Spinner />
        </div>
      )}
      {t.sinFicha && <p className="rounded-control bg-superficie-2 px-3 py-2">{MENSAJE_SIN_FICHA}</p>}
      {t.errorCarga && (
        <Stack espacio={3}>
          <Alerta texto={t.errorCarga} />
          <div>
            <Button variante="secundario" onClick={t.reintentar}>Reintentar</Button>
          </div>
        </Stack>
      )}
      {t.saldo && (
        <>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <MetricCard titulo="Estado de cuenta corriente" tono={t.saldo.tono} valor={t.saldo.valor} detalle={t.saldo.estado} />
            <MetricCard titulo="Aportaste" valor={t.saldo.aportado} detalle="Hasta hoy" />
          </div>
          <DataList etiqueta="Tus aportes" columnas={columnas} filas={t.aportes} claveFila={(a) => a.id} vacio="Todavía no hay aportes." />
          {t.aportes
            .filter((a) => a.adjuntos.length > 0)
            .map((a) => (
              <Desplegable key={a.id} titulo={`Comprobantes del aporte del ${a.fecha} (${a.adjuntos.length})`}>
                <Adjuntos etiqueta={`aporte del ${a.fecha}`} adjuntos={a.adjuntos} rutaDescarga={t.rutaDescarga} puedeEditar={false} error={null} />
              </Desplegable>
            ))}
        </>
      )}
    </Stack>
  );
}
